export default __webpack_public_path__ + "static/media/onboardingWelcome.1225d451.png";